import React, { useState } from "react";
import { defineMessages, useIntl, FormattedMessage } from "react-intl";
import "./Styles.css";
import * as microsoftTeams from "@microsoft/teams-js";
import { Button } from "@fluentui/react-northstar";
import MSGraphAPIClient from "../api-clients/ms-graph";
import maritzAPIClient from "../api-clients/maritz";
import ParticipantListComboBox from "./ParticipantListComboBox";
import RecipientListLabel from "./RecipientListLabel";
import AwardAmountControl from "./AwardAmountControl";
import BuildRecognitionTopBar from "./BuildRecognitionTopBar";

import { TooltipHost } from "@fluentui/react/lib/Tooltip";
import { DefaultButton } from "@fluentui/react/lib/Button";
import { useId } from "@fluentui/react-hooks";

import { awardAmountTypeCollection } from "./../constants/collections";
import formatRecipientList from "../util/formatRecipientList";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCamera,
  faChevronRight,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { debugLog, errorLog } from "../util/debug";
import { UseGlobalState } from "../state/gsh/gsh";
import {
  GENERIC_FAIL_MESSAGE,
  NEED_ADMIN_MESSAGE,
} from "../constants/messages";
import FlexRow from "./recognition/FlexRow";

var teamId = "";
var callerId;
var callerType;

export default function Recognition() {
  const [loading, setLoading] = useState(false);
  const [cnxtProgramName, setCnxtProgramName] = useState("");
  const [isOpenContinueRecognition, setIsOpenContinueRecognition] =
    useState(false);
  const [isOpenSelectProgram, setIsOpenSelectProgram] = useState(false);
  const [isOpenBuildRecognition, setIsOpenBuildRecognition] = useState(false);
  const [isOpenSelectRewardImage, setIsOpenSelectRewardImage] = useState(false);
  const [isOpenCulturalValueSelect, setIsOpenCulturalValueSelect] =
    useState(false);
  const [isOpenRewardMessageEntry, setIsOpenRewardMessageEntry] =
    useState(false);
  const [isOpenAwardSelection, setIsOpenAwardSelection] = useState(false);
  const [programDetails, setProgramDetails] = useState(false);
  const [programBudgets, setProgramBudgets] = useState(false);
  const [budget, setBudget] = useState(false);
  const [logo, setLogo] = useState("");
  const [pointsPer, setPointsPer] = useState();
  const [examinedParticipants, setExaminedParticipants] = useState({
    isValid: [],
    inValid: [],
  });
  const [availablePrograms, setAvailablePrograms] = useState();
  const [selectedCulturalValueId, setSelectedCulturalValueIdState] = useState();
  const [selectedAwardImageId, setSelectedAwardImageIdState] = useState();
  const [selectedBudgetId, setSelectedBudgetIdState] = useState();
  const [selectedProgramId, setSelectedProgramIdState] = useState();
  const [publicMessage, setPublicMessage] = useState("");
  const [privateMessage, setPrivateMessage] = useState("");
  const [recognitionIsPrivate, setRecognitionIsPrivate] = useState(false);
  const [cultureNextMembers, setCultureNextMembers] = useState([]);
  const [memberDropDown, setMemberDropDown] = useState([{}]);
  const tooltipId = useId("tooltip");
  const [showAwardSelection, setShowAwardSelection] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [showBudgetName, setShowBudgetName] = useState(false);
  const [showInsuficientPointsWarning, setShowInsuficientPointsWarning] =
    useState(false);
  const [showPendingApproval, setShowPendingApproval] = useState(false);

  //This states has the values or range objects, depending of program type
  const [awardAmountType, setAwardAmountType] = useState(false);
  // Show the values that a user can recognize, based on a selected budget
  const [errorMsg, setErrorMsg] = useState("");
  const [globalErrorMsg, setGlobalErrorMsg] = useState("");

  const [jwt, setJwt] = useState("");
  const [state, setState] = UseGlobalState();

  const intl = useIntl();
  const messages = defineMessages({
    alertPublicMessageRequired: {
      id: "app.recognition.alertPublicMessageRequired",
      defaultMessage: "Public message is required.",
    },
    alertCannotRetrieveChatMembers: {
      id: "app.recognition.alertCannotRetrieveChatMembers",
      defaultMessage:
        "Can not retrieve chat members until conversation includes at least one message",
    },
    personalNoteTooltip: {
      id: "app.recognition.personalNoteTooltip",
      defaultMessage:
        "The Personal Note is displayed to the recipient(s) and their manager(s), the submitter and submitter's manager.",
    },
    publicMessageTooltip: {
      id: "app.recognition.publicMessageTooltip",
      defaultMessage:
        "The Public Message displays to all users in the Activity Feed when the recipient(s) choose to share their recognition activity.",
    },
    behaviorPlaceholder: {
      id: "app.recognition.behaviorPlaceholder",
      defaultMessage:
        "What behavior are you recognizing? Be specific on how their efforts made a difference. (Required)",
    },
    personalNotePlaceholder: {
      id: "app.recognition.personalNotePlaceholder",
      defaultMessage: "Add a personal note. (Optional)",
    },
  });

  const choose = intl.formatMessage({
    id: "app.recognition.choose",
  });

  const recognitionCriteria = intl.formatMessage({
    id: "app.recognition.chooseCriteria",
  });

  const chooseImage = intl.formatMessage({
    id: "app.recognition.chooseImage",
  });

  const choosePublicMessage = intl.formatMessage({
    id: "app.recognition.choosePublicMessage",
  });

  const chooseAwardAmount = intl.formatMessage({
    id: "app.recognition.chooseAwardAmount",
  });

  const jwtOnChange = (event) => {
    debugLog(event);
    setJwt(event.target.value);
  };

  const jwtKeyPress = (event) => {
    if (event.key === "Enter") {
      console.log("forcing JWT token ");
      state.jwt = jwt;
      setState(state);
    }
  };

  const setErrorMsgDelay = (msg) => {
    setErrorMsg(msg);

    if (!!msg) {
      const element = document.getElementById("err-msg-id");
      if (!!element) {
        element.scrollIntoView(false);
      } else {
        errorLog("unable to find trailing element");
      }

      setTimeout(() => {
        setErrorMsg("");
      }, 3500);
    }
  };

  React.useEffect(
    () => {
      debugLog("Recognition useEffect");
      ShowParticipantsList();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state.consentTried]
  );

  const getMemberList = async () => {
    let result = [];

    try {
      setLoading(true);
      const client = new MSGraphAPIClient();
      const aadToken = await client.getAADToken(state.tenantId);
      let response = await client.getMemberList(
        aadToken,
        callerType,
        callerId,
        teamId
      );
      debugLog("post getMember: ", response);
      result = response[1];

      if (response[0] === 403) {
        if (state.consentTried) {
          setGlobalErrorMsg(NEED_ADMIN_MESSAGE);
        } else {
          microsoftTeams.authentication.authenticate({
            url: client.getConsentUrl(state.tenantId),
            isExternal: false,
            width: 600,
            height: 535,
          }).then((result) => {
              debugLog("inside success callback of consent", result);
              debugLog("refreshing");
              state.consentTried = true;
              setState(state);
              setGlobalErrorMsg("");
              setLoading(false);
          }).catch((reason) => {
              debugLog("inside failed callback of consent", reason);
              setGlobalErrorMsg(NEED_ADMIN_MESSAGE);
              setLoading(false);
          });
        }
      }
    } catch (error) {
      errorLog("error getting member list: ", error);
    }

    return result;
  };

  const ShowParticipantsList = async () => {
    debugLog("showParticipantList...");

    let contextUserName = "";
    microsoftTeams.app.getContext().then((context) => {
      /* ... */ debugLog("Recognition context ", context);

      contextUserName = context.user.userPrincipalName;

      if (context.chat.id) {
        callerType = "chat";
        callerId = context.chat.id;

        if (callerId && callerId.includes("preview")) {
          alert(intl.formatMessage(messages.alertCannotRetrieveChatMembers));
          // contextOK = false;
        }
      } else if (context.channel.id) {
        callerType = "channel";
        callerId = context.channel.id;
        teamId = context.team.groupId; // need the team as a parent - that for some reason is stored in groupId!
      } else if (context.team.internalId) {
        callerType = "team";
        callerId = context.team.internalId;
      } else {
        callerType = "aad";
      }
    });

    if (
      examinedParticipants.isValid.length === 0 &&
      examinedParticipants.inValid.length === 0
    ) {
      setLoading(true);
      var result = await getMemberList(true);

      if (result.length > 0) {
        debugLog("context user name ", contextUserName);

        var membersTmp = [];
        result.forEach((member) => {
          if (!!!member.email) {
            if (!!member.mail) {
              member.email = member.mail;
            } else {
              member.email = "no@email.com";
            }
          }

          if (!!!member.displayName) {
            member.displayName = "Unknown User";
          }

          if (member.email.toUpperCase() !== contextUserName.toUpperCase()) {
            membersTmp.push(member);
          }
        });

        setCultureNextMembers(membersTmp);
        setMemberDropDown(
          membersTmp.map((member) => {
            return { label: member.displayName, value: member.email };
          })
        );

        var maritz = new maritzAPIClient();
        var participantStatusCheck =
          await maritz.validateMaritzParticipantsByEmail(
            membersTmp.map((input) => {
              return input.email ?? "no@email.com";
            })
          );

        var tmpParticipants = {
          isValid: [],
          inValid: [],
        };

        participantStatusCheck.map((result) => {
          var detailedRecord = membersTmp.filter((e) =>
            [e.email, e.mail].includes(result.participantId)
          )[0];

          if (result.id === null) {
            tmpParticipants.inValid.push(detailedRecord);
          } else {
            detailedRecord.maritzId = result.id;
            tmpParticipants.isValid.push(detailedRecord);
          }
          debugLog("tmpParticipants: ", tmpParticipants);
          return null;
        });

        setExaminedParticipants(tmpParticipants);

        if (tmpParticipants.inValid.length === 0) {
          setupProgramSelectDialog(tmpParticipants.isValid);
          setIsOpenSelectProgram(true);
        } else {
          setIsOpenContinueRecognition(true);
        }
      }

      setLoading(false);
    }
  };

  const continueRecognitionClick = async () => {
    setupProgramSelectDialog();
  };

  const programSelectionContinueButtonClick = async (e, inputProgramId) => {
    var boxes = document.getElementsByClassName("programCard");
    [].forEach.call(boxes, (el) => {
      el.classList.remove("program-selected");
    });
    e.currentTarget.classList.add("program-selected");
    var maritz = new maritzAPIClient();
    setSelectedProgramIdState(inputProgramId);
    setLoading(true);
    var localProgramDetails = await maritz.getProgramDetailsById(
      inputProgramId
    );

    setProgramDetails(localProgramDetails);
    if (localProgramDetails.awardAmountPolicy) {
      //Assuming there is   only two award tiers type.
      setAwardAmountType(
        localProgramDetails.awardAmountPolicy?.values
          ? awardAmountTypeCollection.values
          : awardAmountTypeCollection.range
      );
    }
    setShowPendingApproval(localProgramDetails?.approvalRequired);

    const localProgramBudgets = await maritz.getBudgetsByProgramId(
      inputProgramId
    );
    setProgramBudgets(localProgramBudgets);
    setShowInsuficientPointsWarning(
      !isAwardAmountProgramValid(localProgramDetails, localProgramBudgets)
    );

    //if  awardAmountPolicy is null, it is a program without value
    if (
      !localProgramDetails.awardAmountPolicy ||
      !("required" in localProgramDetails.awardAmountPolicy)
    ) {
      setShowBudgetName(false);
    }
    // check if program award is optional, if it  is, then show budget section.
    else if (
      localProgramDetails.awardAmountPolicy?.required === true ||
      (localProgramDetails.awardAmountPolicy?.required === false &&
        localProgramBudgets.length)
    ) {
      setShowBudgetName(true);
    } else {
      setShowBudgetName(false);
    }

    //Check the award property in order to check if the program needs a budget as required
    let localShowAwardSelection = false;
    if (
      localProgramDetails.awardAmountPolicy &&
      localProgramDetails.awardAmountPolicy?.required === true
    ) {
      // if the 'required' in the award is true, we'll show the the option regardless of budget, as the config says it's required
      localShowAwardSelection = true;
    } else if (localProgramDetails.awardAmountPolicy) {
      // award policy exists, and isn't required.  We'll show it iff the user has a budget
      if (localProgramBudgets.length) {
        localShowAwardSelection = true;
      }
    } // else there is no awardAmountPolicy section, so nothing to display in award

    setShowAwardSelection(localShowAwardSelection);

    // new program was selected, need to start with an empty budget display
    setBudget(false);

    if (localProgramBudgets.length === 1) {
      const onlyBudget = localProgramBudgets[0];
      setBudget(onlyBudget);
      setSelectedBudgetIdState(onlyBudget.id);
    }

    setCnxtProgramName(localProgramDetails.name);

    setIsOpenSelectProgram(false);
    setIsOpenBuildRecognition(true);

    window.scrollTo(0, 0);

    setLoading(false);
  };

  const culturalValueClick = async (e, id) => {
    var boxes = document.getElementsByClassName("cultural-value-selector");
    [].forEach.call(boxes, (el) => {
      el.classList.remove("value-selected");
    });

    e.target.classList.add("value-selected");
    setSelectedCulturalValueIdState(id);
    setIsOpenCulturalValueSelect(false);
    setIsOpenBuildRecognition(true);
  };

  const setupProgramSelectDialog = async (participants) => {
    if (!participants) {
      participants = examinedParticipants.isValid;
    }
    debugLog("setupProgramSelectDialog: ", participants);
    var maritz = new maritzAPIClient();
    setLoading(true);
    var tmpPrograms = await maritz.getProgramsForSelectedParticipants(
      participants.map((member) => member.maritzId)
    );
    const notNominationPrograms = tmpPrograms.filter(program => program.programType !== 'NOMINATION');
    setAvailablePrograms(notNominationPrograms);
    setIsOpenContinueRecognition(false);
    setIsOpenSelectProgram(true);
    setLoading(false);
  };

  const toggleCulturalValueSelect = (val) => {
    setIsOpenCulturalValueSelect(val);
    setIsOpenBuildRecognition(!val);
  };

  const toggleRewardImageSelect = (val) => {
    setIsOpenSelectRewardImage(val);
    setIsOpenBuildRecognition(!val);
  };

  const toggleRewardMessageEntry = (val) => {
    setIsOpenRewardMessageEntry(val);
    setIsOpenBuildRecognition(!val);
    window.scrollTo(0, 0);
  };

  const toggleRewardSelect = (val) => {
    setIsOpenAwardSelection(val);
    setIsOpenBuildRecognition(!val);
  };

  const setSelectedCulturalValueId = (valueId) => {
    setSelectedCulturalValueIdState(valueId);
    setIsOpenCulturalValueSelect(false);
    setIsOpenBuildRecognition(true);
  };

  const setSelectedAwardImageId = (imageId) => {
    setSelectedAwardImageIdState(imageId);
    setIsOpenSelectRewardImage(false);
    setIsOpenBuildRecognition(true);
  };

  const displaySelectedCulturalValueName = () => {
    var valueName;
    if (selectedCulturalValueId) {
      valueName = programDetails.culturalValues.filter(
        (e) => e.id === selectedCulturalValueId
      )[0].name;
    }

    if (valueName) {
      return valueName;
    }

    return selectValue;
  };

  const displaySelectedAwardImage = () => {
    var img;

    if (selectedAwardImageId) {
      img = programDetails.recognitionGalleryImages.filter(
        (e) => e.id === selectedAwardImageId
      )[0];
    }

    if (img) {
      return <img alt="Award" src={img.url} className="flex-auto max-w-lg" />;
    }

    return "";
  };

  const messageApplyButtonClick = () => {
    if (publicMessage === "") {
      alert(intl.formatMessage(messages.alertPublicMessageRequired));
      return;
    }

    toggleRewardMessageEntry(false);
  };

  const DisplayAwardMessage = () => {
    if (publicMessage !== "") {
      return (
        <div>
          <div className="message-head font-bold">
            <FormattedMessage
              id="app.recognition.publicMessage"
              defaultMessage="Public Message*"
            />
          </div>
          <div className="message-text">{publicMessage}</div>
          {privateMessage !== "" && (
            <div className="mt-4 mb-2">
              <div className="message-head font-bold">
                <FormattedMessage
                  id="app.recognition.privateMessage"
                  defaultMessage="Private Message*"
                />
              </div>
              <div className="message-text">{privateMessage}</div>
            </div>
          )}
          <div className="clear-both" />
        </div>
      );
    } else {
      return behaviorPlaceholder;
    }
  };

  const updateStateFromAwardAmountControl = (v) => {
    setPointsPer(v);
    toggleRewardSelect(false);
  };

  const displayPointsPer = () => {
    if (pointsPer) {
      return <div>{pointsPer}</div>;
    }

    return choose;
  };

  const processRecognition = () => {
    setIsSubmitLoading(true);
    var submission = {
      recipients: [],
      programId: selectedProgramId,
      culturalValueIds: [selectedCulturalValueId], // api accepts multiple even though UI does not
      imageId: selectedAwardImageId,
      publicMessage: publicMessage,
      personalNote: privateMessage,
      notificationPersonIds: [], // not supported in UI
      private: recognitionIsPrivate,
    };

    examinedParticipants.isValid.forEach((participant) => {
      submission.recipients.push({
        id: participant.maritzId,
        award: pointsPer
          ? {
              budgetId: selectedBudgetId,
              amount: pointsPer,
            }
          : undefined,
      });
    });

    // validation...
    const selectedValueName = programDetails.culturalValues.filter(
      (e) => e.id === selectedCulturalValueId
    )[0]?.name;
    if (programDetails.culturalValues.length > 0) {
      if (!!!selectedValueName) {
        // HERE
        setErrorMsgDelay(recognitionCriteria);
        setIsSubmitLoading(false);
        return;
      }
    } else {
      submission.culturalValueIds = null;
    }
    const awardImage = programDetails.recognitionGalleryImages.filter(
      (e) => e.id === selectedAwardImageId
    )[0]?.url;
    if (!!!awardImage) {
      setErrorMsgDelay(chooseImage);
      setIsSubmitLoading(false);
      return;
    }

    if (!!!publicMessage) {
      setErrorMsgDelay(choosePublicMessage);
      setIsSubmitLoading(false);
      return;
    }

    if (programDetails?.awardAmountPolicy?.required && !!!pointsPer) {
      setErrorMsgDelay(chooseAwardAmount);
      setIsSubmitLoading(false);
      return;
    }

    debugLog("sending: ", submission);

    const maritz = new maritzAPIClient();
    maritz
      .submitRecognition(submission)
      .then((response) => {
        debugLog("response now: ", response);

        if (!!!response || !!response.fault) {
          setErrorMsgDelay(GENERIC_FAIL_MESSAGE);
        } else if (response instanceof Error) {
          errorLog(response.message);
          setErrorMsgDelay(response.message);
        } else {
          microsoftTeams.dialog.url.submit({
            recipients: formatRecipientList(examinedParticipants.isValid),
            pointsPer: pointsPer,
            value: selectedValueName
              ? `${textBeforeProgramValue}${selectedValueName}${textBetweenProgramValueAndName}${cnxtProgramName}${textAfterProgramName}`
              : "",
            publicMessage: publicMessage,
            personalNote: privateMessage,
            awardImage,
            logo: JSON.parse(window.localStorage.getItem("projectProfile"))
              .branding.imageUrls.logo,
          });
        }
        setIsSubmitLoading(false);
      })
      .catch((err) => {
        errorLog("error: ", err);
        debugLog("error: ", err);
        debugLog(window.localStorage);
        setErrorMsgDelay(GENERIC_FAIL_MESSAGE);
        setIsSubmitLoading(false);
      });
  };

  const displayLogo = () => {
    const brandLogo =
      JSON.parse(window.localStorage.getItem("projectProfile")).branding
        .imageUrls.logo || "";
    if (brandLogo) {
      return (
        <img
          src={brandLogo}
          className="img-brandLogo relative z-50"
          alt="Logo"
        />
      );
    }
  };

  const displayBudget = () => {
    if (budget) {
      return (
        <>
          {budget.name}{" "}
          {budget.displayBalance === true
            ? `(${budget.balance.toLocaleString()})`
            : ""}
        </>
      );
    }
    return "";
  };

  const calloutProps = { gapSpace: 0 };
  const hostStyles = { root: { display: "inline-block", border: 0 } };
  const personalNoteTooltip = intl.formatMessage(messages.personalNoteTooltip);
  const personalNotePlaceholder = intl.formatMessage(
    messages.personalNotePlaceholder
  );
  const publicMessageTooltip = intl.formatMessage(
    messages.publicMessageTooltip
  );
  const behaviorPlaceholder = intl.formatMessage(messages.behaviorPlaceholder);

  const displayBudegetDetailsOrSelect = () => {
    if (
      !programBudgets.length ||
      !isAwardAmountProgramValid(programDetails, programBudgets)
    ) {
      return null;
    }

    let validBudgets = getValidBudgets(programDetails, programBudgets);
    debugLog("valid budgets: ", validBudgets);
    if (!validBudgets.length) {
      return null;
    }

    if (validBudgets.length === 1) {
      if (selectedBudgetId !== validBudgets[0].id) {
        setSelectedBudgetIdState(validBudgets[0].id);
        setBudget(validBudgets[0]);
      }
    } else {
      // validBudgets.length > 1
      return (
        <>
          <label>
            <FormattedMessage
              id="app.recognition.selectAwardBudget"
              defaultMessage="Select Award Budget"
            />
            <br />
          </label>
          <select
            defaultValue={"default"}
            className="border mt-2 mb-5 pl-3 pr-3 min-h-[40] w-[100%]"
            value={selectedBudgetId}
            onChange={(e) => {
              if (e.target.value === "0") {
                e.target.selectedIndex = 1;
                return false;
              }
              let selectedBudget = programBudgets.filter(
                (b) => b.id === e.target.value
              )[0];

              setSelectedBudgetIdState(e.target.value);
              setBudget({ ...selectedBudget });
            }}
          >
            <option value="0">
              {intl.formatMessage({
                id: "app.recognition.selectBudget",
                defaultMessage: "Select Budget",
              })}
            </option>
            {validBudgets &&
              validBudgets.map((budget, index) => {
                return (
                  <option key={`budget-op-${index}`} value={budget.id}>
                    {budget.name} ({budget.balance})
                  </option>
                );
              })}
          </select>
        </>
      );
    }

    return (
      <>
        <div className="mt-2 mb-5">
          <div className="float-left font-bold">
            <FormattedMessage
              id="app.recognition.selectedBudget"
              defaultMessage="Selected Budget:"
            />
          </div>
          <div className="float-left pl-1 pr-3">{displayBudget()}</div>
          <div className="clear-both"></div>
        </div>
      </>
    );
  };

  // Validate if a  program requires awards, and check if the budget asociated to the program achives the minumun needed
  const isAwardAmountProgramValid = (programDesc, programBgts) => {
    //Check if the program has a budget as mandatory
    if (
      !programDesc.awardAmountPolicy ||
      ("required" in programDesc.awardAmountPolicy &&
        programDesc.awardAmountPolicy?.required === false)
    ) {
      //This program does not require award, no extra validation  is needed.
      return true;
    }
    // Check if the  program has no budget assigned
    if (programBgts && programBgts.length <= 0) {
      //This program have no budgets assigned, and those are mandatory.
      return false;
    }

    //Check if this program has valid budgets that reach  the minimal required amount
    if (getValidBudgets(programDesc, programBgts).length <= 0) {
      return false;
    }
    return true;
  };

  const getValidBudgets = (programDetails, budgetList = []) => {
    if (!programDetails || !budgetList.length) return [];

    let programValues =
      programDetails.awardAmountPolicy?.values ||
      programDetails.awardAmountPolicy?.range ||
      [];
    programValues = Object.values(programValues);
    //Check if the program has multiple budgets
    if (budgetList.length > 1) {
      //Search  for the program value that has the minimum value
      return budgetList.filter(
        (element) =>
          element.balance >=
          Math.min(...programValues) * examinedParticipants.isValid.length
      );
    }
    return budgetList[0].balance >=
      Math.min(...programValues) * examinedParticipants.isValid.length
      ? [budgetList[0]]
      : [];
  };

  const resetProgramSelection = () => {
    setSelectedCulturalValueId(undefined);
    setSelectedAwardImageIdState(undefined);
    setPointsPer(undefined);
    setIsOpenBuildRecognition(false);
    setIsOpenSelectProgram(true);
    setPublicMessage("");
    setPrivateMessage("");
  };

  const buildRecognitionTitle = intl.formatMessage({
    id: "app.recognition.buildRecognitionTitle",
  });

  const messageTitle = intl.formatMessage({
    id: "app.recognition.messageTitle",
  });

  const selectValue = intl.formatMessage({
    id: "app.recognition.selectAValue",
  });

  const selectImage = intl.formatMessage({
    id: "app.recognition.selectImage",
  });

  const selectAward = intl.formatMessage({
    id: "app.recognition.selectAward",
  });

  const textBeforeProgramValue = intl.formatMessage({
    id: "app.recognition.textBeforeProgramValue",
  });

  const textBetweenProgramValueAndName = intl.formatMessage({
    id: "app.recognition.textBetweenProgramValueAndName",
  });

  const textAfterProgramName = intl.formatMessage({
    id: "app.recognition.textAfterProgramName",
  });

  return (
    (<div className="App">
      {displayLogo()}
      {!!globalErrorMsg && <div className="error-msg">{globalErrorMsg}</div>}
      {(loading || isSubmitLoading) && (
        <div class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-40 overflow-hidden bg-white flex flex-col items-center justify-center">
          <div class="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4"></div>
        </div>
      )}
      {/* select public/private messages */}
      {!!isOpenRewardMessageEntry && (
        <div className="p-[2px]">
          <BuildRecognitionTopBar
            title={messageTitle}
            returnFunction={() => {
              setIsOpenRewardMessageEntry(false);
              setIsOpenBuildRecognition(true);
            }}
          />

          <FlexRow>
            <h3 className="mb-2 w-full text-left">
              <FormattedMessage
                id="app.recognition.publicMessageTitle"
                defaultMessage="Public Message *"
              />
              <TooltipHost
                content={publicMessageTooltip}
                id={tooltipId}
                calloutProps={calloutProps}
                styles={hostStyles}
              >
                <DefaultButton aria-describedby={tooltipId}>
                  <FontAwesomeIcon
                    icon={faInfoCircle}
                    className="text-brandPrimary"
                  />
                </DefaultButton>
              </TooltipHost>
            </h3>
          </FlexRow>

          <FlexRow>
            <textarea
              className="w-full message-entry border border-gray-900 p-4 rounded resize-none"
              placeholder={behaviorPlaceholder}
              onChange={(e) => {
                setPublicMessage(e.target.value);
              }}
            >
              {publicMessage}
            </textarea>
          </FlexRow>

          <FlexRow>
            <h3 className="mt-5 mb-2 flex-auto text-left w-full">
              <FormattedMessage
                id="app.recognition.personalNoteTitle"
                defaultMessage="Personal Note"
              />
              <TooltipHost
                content={personalNoteTooltip}
                id={tooltipId}
                calloutProps={calloutProps}
                styles={hostStyles}
              >
                <DefaultButton aria-describedby={tooltipId}>
                  <FontAwesomeIcon
                    icon={faInfoCircle}
                    className="text-brandPrimary"
                  />
                </DefaultButton>
              </TooltipHost>
            </h3>
          </FlexRow>

          <FlexRow>
            <textarea
              className="w-full message-entry border border-gray-900 p-4 rounded resize-none"
              placeholder={personalNotePlaceholder}
              onChange={(e) => {
                setPrivateMessage(e.target.value);
              }}
            >
              {privateMessage}
            </textarea>
          </FlexRow>

          <FlexRow addlClassName="mt-5">
            <div className="flex-auto w-full">
              <label className="flex items-center">
                <div className="float-left">
                  <input
                    type="checkbox"
                    className="rounded w-6 h-6"
                    checked={recognitionIsPrivate}
                    onChange={(e) => {
                      setRecognitionIsPrivate(e.target.checked);
                    }}
                  />
                </div>
                <div className="float-left ml-2">
                  <div className="text-left">
                    <FormattedMessage
                      id="app.recognition.makePrivate"
                      defaultMessage="Make this Recognition Private"
                    />
                  </div>
                </div>
              </label>
              <div className="clear-both mt-2 text-xs text-slate-500 text-left">
                <FormattedMessage
                  id="app.recognition.recognitionVisibility"
                  defaultMessage="This recognition will only be seen by you, the recipient and the recipient's manager"
                />
              </div>
            </div>
          </FlexRow>

          <FlexRow addlClassName="mt-5 mb-5">
            <Button
              className="text-lg px-4 py-2 rounded primary-btn"
              onClick={() => {
                messageApplyButtonClick();
              }}
            >
              <FormattedMessage
                id="app.recognition.apply"
                defaultMessage="Apply"
              />
            </Button>
          </FlexRow>
        </div>
      )}
      {/* continue recognitions */}
      {!!isOpenContinueRecognition && (
        <div className="p-[2px]">
          <FlexRow addlClassName="text-left">
            <div className="flex-auto w-full">
              <div className="text-center text-brandPrimary text-lg mb-5">
                <FormattedMessage
                  id="app.recognition.continueRecognitionTitle"
                  defaultMessage="Continue with Recognition"
                />
              </div>
              <div className="border-y border-gray-darker py-2 pl-8 w-full">
                <FormattedMessage
                  id="app.participantsView.valid"
                  defaultMessage="{valid} user(s) are eligible for Recognition"
                  values={{ valid: examinedParticipants.isValid.length }}
                />
              </div>
              <div className="py-2 pl-8 w-full text-red-800">
                <FormattedMessage
                  id="app.participantsView.invalid"
                  defaultMessage="{invalid} user(s) are not eligible for Recognition"
                  values={{ invalid: examinedParticipants.inValid.length }}
                />
              </div>
              <ParticipantListComboBox
                participants={examinedParticipants.inValid}
              />
              <div className="text-xs ml-8 mt-2">
                <FormattedMessage
                  id="app.recognition.continueRecognitionNote"
                  defaultMessage="Selecting Continue will create a recognition to all eligible participants"
                />
              </div>
              <div className="mt-5 mb-2 text-center">
                <Button
                  className="border-2 border-solid bg-white cancel-btn text-lg px-4 py-[.4rem] rounded mr-5"
                  onClick={() => {
                    microsoftTeams.dialog.url.submit();
                  }}
                >
                  <FormattedMessage
                    id="app.recognition.cancel"
                    defaultMessage="Cancel"
                  />
                </Button>
                <Button
                  className="text-lg px-4 py-2 rounded primary-btn"
                  onClick={continueRecognitionClick}
                  disabled={examinedParticipants.isValid.length === 0}
                >
                  <FormattedMessage
                    id="app.recognition.continue"
                    defaultMessage="Continue"
                  />
                </Button>
              </div>
            </div>
          </FlexRow>
        </div>
      )}
      {/* select program */}
      {!!isOpenSelectProgram && (
        <div className="text-left p-[2px]">
          <div
            className="text-center text-brandPrimary font-bold my-2 mx-8"
            style={{ fontSize: "120%" }}
          >
            <FormattedMessage
              id="app.recognition.buildRecognitionTitle"
              defaultMessage="Build a Recognition"
            />
          </div>
          <FlexRow>
            <div className="w-full">
              <hr />
              <div className="mt-5 pl-5">
                <RecipientListLabel
                  participants={examinedParticipants.isValid}
                />
                <p className="text-brandPrimary text-center text-lg mt-5">
                  <FormattedMessage
                    id="app.recognition.selectProgramTitle"
                    defaultMessage="Select a Program:"
                  />
                </p>
              </div>

              <div className="mt-5">
                <div>
                  {(!!!availablePrograms || availablePrograms.length === 0) && (
                    <div className="p1 text-center">
                      <FormattedMessage
                        id="app.recognition.noProgramsAvailable"
                        defaultMessage="You have no programs available for these selected participants."
                      />
                    </div>
                  )}

                  {availablePrograms?.length > 0 &&
                    availablePrograms.map((program, index) => {
                      return (
                        <div
                          key={`program-card-${index}`}
                          className="programCard"
                          onClick={(e) => {
                            programSelectionContinueButtonClick(e, program.id);
                          }}
                        >
                          <div className="p1">{program.name}</div>
                          <div className="p3 ">{program.description}</div>
                          <div className="clear-both" />
                        </div>
                      );
                    })}
                  <div style={{ clear: "both" }}></div>
                </div>
              </div>
            </div>
          </FlexRow>
        </div>
      )}
      {/* build recognition - hub (center) of hub/spoke design */}
      {!!isOpenBuildRecognition && (
        <div className="p-[2px]">
          <BuildRecognitionTopBar
            bigTitle={buildRecognitionTitle}
            returnFunction={() => {
              resetProgramSelection();
            }}
          />

          <FlexRow>
            <div className="mt-5 font-black text-sm text-left w-full">
              {cnxtProgramName}
            </div>
          </FlexRow>

          {showBudgetName && budget && (
            <FlexRow>
              <div className="font-black text-sm mb-3 text-left w-full">
                <FormattedMessage
                  id="app.recognition.budget"
                  defaultMessage="Budget"
                />
                : {displayBudget()}
              </div>
            </FlexRow>
          )}

          <FlexRow>
            <div className="w-full">
              <hr />
            </div>
          </FlexRow>

          <FlexRow>
            <div className="mb-5 mt-5 w-full">
              <RecipientListLabel participants={examinedParticipants.isValid} />
            </div>
          </FlexRow>

          {programDetails &&
            programDetails.culturalValues &&
            programDetails.culturalValues.length > 0 && (
              <FlexRow>
                <div className="text-left w-full">
                  <h4 className="font-bold">
                    <FormattedMessage
                      id="app.recognition.value"
                      defaultMessage="Value"
                    />
                  </h4>
                  <p className="text-xs text-slate-500">
                    <FormattedMessage
                      id="app.recognition.selectValue"
                      defaultMessage="Select the value which best describes the behavior you're recognizing."
                    />
                  </p>
                  <div
                    className="border border-slate-500 rounded pl-3 pt-2 align-middle text-slate-500 min-h-[40] cursor-pointer"
                    onClick={() => {
                      toggleCulturalValueSelect(true);
                    }}
                  >
                    <div className="flex">
                      <div className="flex-1">
                        {displaySelectedCulturalValueName()}
                        <div className="clear-both" />
                      </div>
                      <div className="mr-2">
                        <FontAwesomeIcon
                          icon={faChevronRight}
                          size="xl"
                          className="text-brandPrimary"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </FlexRow>
            )}

          <FlexRow>
            <div className="text-left w-full">
              <h4 className="mt-5 font-bold">
                <FormattedMessage
                  id="app.recognition.insertImageTitle"
                  defaultMessage="Insert an Image"
                />
              </h4>
              <p>
                <div
                  className="launch-link text-xs underline text-slate-500 ml-3 mb-3 cursor-pointer"
                  onClick={() => {
                    toggleRewardImageSelect(true);
                  }}
                >
                  {" "}
                  <FontAwesomeIcon icon={faCamera} /> &nbsp;&nbsp;
                  <FormattedMessage
                    id="app.recognition.imageGallery"
                    defaultMessage="Image Gallery"
                  />
                </div>
              </p>
            </div>
          </FlexRow>

          <FlexRow>{displaySelectedAwardImage()}</FlexRow>

          <FlexRow>
            <div className="w-full text-left">
              <h4 className="mt-5 font-bold">
                <FormattedMessage
                  id="app.recognition.messageTitle"
                  defaultMessage="Message"
                />
              </h4>
              <div
                className="border border-slate-500 rounded pl-3 pt-2 align-middle text-slate-500 min-h-[40] cursor-pointer"
                onClick={() => {
                  toggleRewardMessageEntry(true);
                }}
              >
                <div className="flex">
                  <div className="flex-1">{DisplayAwardMessage()}</div>
                  <div className="mr-2">
                    <FontAwesomeIcon
                      icon={faChevronRight}
                      size="xl"
                      className="text-brandPrimary"
                    />
                  </div>
                </div>
              </div>
            </div>
          </FlexRow>

          {!showInsuficientPointsWarning && showAwardSelection && (
            <FlexRow>
              <div className="text-left w-full">
                <h4 className="mt-5 font-bold">
                  <FormattedMessage
                    id="app.recognition.selectAwardTitle"
                    defaultMessage="Select an Award"
                  />
                </h4>
                <div
                  className="border border-slate-500 rounded pl-3 pt-2 align-middle text-slate-500 min-h-[40] cursor-pointer"
                  onClick={() => {
                    toggleRewardSelect(true);
                  }}
                >
                  <div className="flex">
                    <div className="flex-1">{displayPointsPer()}</div>
                    <div className="mr-2">
                      <FontAwesomeIcon
                        icon={faChevronRight}
                        size="xl"
                        className="text-brandPrimary"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </FlexRow>
          )}

          {showInsuficientPointsWarning && (
            <FlexRow>
              <div className="w-full error-msg">
                <FormattedMessage
                  id="app.recognition.insufficientPoints"
                  defaultMessage="We're sorry, but you do not currently have sufficient points
                available to give recognition in the program you have selected. Please check back later when
                additional points have been allocated by your program administrator or select another program."
                />
              </div>
            </FlexRow>
          )}

          <FlexRow>
            <div className="w-full">
              <div className="clear-both" />
              <div className="relative text-center mt-5">
                <Button
                  disabled={showInsuficientPointsWarning || isSubmitLoading}
                  className="text-lg px-4 py-2 rounded primary-btn"
                  onClick={() => {
                    processRecognition();
                  }}
                >
                  <FormattedMessage
                    id="app.recognition.submit"
                    defaultMessage="Submit"
                  />
                </Button>
              </div>
              <div className="error-msg">{errorMsg}</div>
              <div id="err-msg-id">&nbsp;&nbsp;&nbsp;&nbsp;</div>
            </div>
          </FlexRow>
          {showPendingApproval && (
            <FlexRow>
              <div className="w-full">
                <div className="clear-both" />
                <div className="relative text-center mb-5 error-msg">
                  <FormattedMessage
                    id="app.recognition.pendingApprovalNotice"
                    defaultMessage="*This recognition will be sent for approval."
                  />
                </div>
              </div>
            </FlexRow>
          )}
        </div>
      )}
      {/* cultural values modal */}
      {!!isOpenCulturalValueSelect && (
        <div className="p-[2px]">
          <BuildRecognitionTopBar
            title={selectValue}
            returnFunction={() => {
              setIsOpenCulturalValueSelect(false);
              setIsOpenBuildRecognition(true);
            }}
          />
          <FlexRow>
            <div className="w-full">
              {(programDetails === undefined ||
                (programDetails.culturalValues &&
                  programDetails.culturalValues.length === 0)) && (
                <div className="error">
                  <FormattedMessage
                    id="app.recognition.noAvailableValues"
                    defaultMessage="There are no available values."
                  />
                </div>
              )}
              {programDetails.culturalValues &&
                programDetails.culturalValues.map((value, index) => {
                  return (
                    <div
                      key={`cult-value-${index}`}
                      className="border border-slate-500 text-slate-500 pl-3 pt-2 mb-4 min-h-[40] align-middle rounded w-[100%] cursor-pointer text-left"
                      onClick={(e) => {
                        culturalValueClick(e, value.id);
                      }}
                    >
                      {value.name}
                    </div>
                  );
                })}
            </div>
          </FlexRow>
        </div>
      )}
      {/* image selection panel */}
      {!!isOpenSelectRewardImage && (
        <div className="p-[2px]">
          <BuildRecognitionTopBar
            title={selectImage}
            returnFunction={() => {
              setIsOpenSelectRewardImage(false);
              setIsOpenBuildRecognition(true);
            }}
          />
          <FlexRow>
            <div className="w-full">
              {(programDetails === undefined ||
                programDetails.recognitionGalleryImages === null) && (
                <div className="error">
                  <FormattedMessage
                    id="app.recognition.noAvailableImages"
                    defaultMessage="There are no available award images."
                  />
                </div>
              )}

              <div className="flex flex-wrap justify-center">
                {programDetails.recognitionGalleryImages &&
                  programDetails.recognitionGalleryImages.map((img, index) => {
                    return (
                      <div
                        key={`image-ndx-${index}`}
                        className="award-image-select mr-5"
                        onClick={() => {
                          setSelectedAwardImageId(img.id);
                        }}
                      >
                        <img alt="" src={img.url} />
                      </div>
                    );
                  })}
              </div>
            </div>
          </FlexRow>
        </div>
      )}
      {/* open award selection */}
      {!!isOpenAwardSelection && (
        <div className="p-[2px]">
          <BuildRecognitionTopBar
            title={selectAward}
            returnFunction={() => {
              toggleRewardSelect(false);
            }}
          />
          <FlexRow>
            <div className="w-full text-left">
              {displayBudegetDetailsOrSelect()}
              {programDetails.awardAmountPolicy !== null && (
                <AwardAmountControl
                  program={programDetails}
                  budgetList={budget}
                  recipients={examinedParticipants.isValid}
                  updateCallback={updateStateFromAwardAmountControl}
                />
              )}
            </div>
          </FlexRow>
        </div>
      )}
      {process.env.REACT_APP_HACK_JWT === "true" && (
        <input
          type="text"
          value={jwt}
          onChange={jwtOnChange}
          onKeyPress={jwtKeyPress}
        />
      )}
    </div>)
  );
}
